<div
  class="h-[102px] w-full flex gap-3 rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] border border-1 border-outline dark:border-outline-darkmode p-4"
>
  <ui-skeleton class="flex-none w-1 rounded-full" />
  <div class="flex flex-col sm:flex-row gap-3 flex-1 overflow-hidden">
    <div class="flex flex-col gap-1 justify-evenly">
      <div>
        <ui-skeleton class="block h-3 w-[135px] rounded-full" />
      </div>
      <div>
        <ui-skeleton class="block h-3 w-[241px] max-w-full rounded-full" />
      </div>
    </div>
    <div class="flex flex-col gap-1 justify-evenly">
      <div class="hidden sm:block">
        <ui-skeleton class="block h-3 w-[154px] rounded-full" />
      </div>
      <div class="inline-flex justify-start items-center gap-1.5 flex-wrap content-center">
        <ui-skeleton class="block h-4 w-[110px] rounded" />
        <ui-skeleton class="block h-4 w-[91px] rounded" />
        <ui-skeleton class="block h-4 w-[62px] rounded-full" />
      </div>
    </div>
  </div>
  <div class="flex items-center">
    <ui-skeleton class="block h-10 w-10 sm:w-[100px] rounded-md" />
  </div>
</div>
